import { render, staticRenderFns } from "./ProjPackages.vue?vue&type=template&id=a8bcc6ec&"
import script from "./ProjPackages.vue?vue&type=script&lang=js&"
export * from "./ProjPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports